import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
} from "../../config/axiosInstance";
// ---------------------Payment-listing--------------------------
export const paymentListApi = async (data) => {
    const endPoint =
        `payment` +
        "?" +
        new URLSearchParams({ ...data }).toString();
    return await axios.get(endPoint, setJwtToken());
};

